module.exports = __webpack_public_path__ + "static/media/cow-farm.6dd36bb0.PNG";